import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

import { CssBaseline, GlobalStyles } from '@mui/material'
import { Route, Routes } from 'react-router-dom'
import CanonicalUpdater from './components/utils/CanonicalHelper'
import { detectAndSetCurrency } from './utils/market'
import './index.css'

// Detect visitor currency from browser locale and set the cc_currency
// cookie BEFORE any REST request for page content. The {price} placeholder
// in PHP reads this cookie, so the first /pricing/ fetch returns the right
// currency without a reload.
detectAndSetCurrency();
// import TestCard from './routes/TestCard'

import "@fontsource/kanit/300.css"
import "@fontsource/kanit/400.css"
import "@fontsource/kanit/500.css"
import "@fontsource/kanit/900.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import "@fontsource/roboto/900.css"

console.log('Font CSS imported');

document.fonts.ready.then(() => {
  console.log('Fonts loaded:', [...document.fonts].map(f => `${f.family} ${f.weight}`));
});

if (process.env.NODE_ENV === 'production') {
  console.log = () => { }
  console.error = () => { }
  console.debug = () => { }
}


// Development mock data (will be replaced with WordPress data in production)
const mockWpData = {
  siteTitle: 'CardCam.io',
  homeUrl: '/',
  // Add any other data your app needs
}

const wpData = window.wpSettings || mockWpData;

// Single catch-all route — App resolves market and slug from the URL itself
// (see utils/market.js). No need to enumerate prefixes here.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' }, body: { backgroundColor: '#fffefb !important' } }} />
      <CssBaseline />
      <BrowserRouter>
      <CanonicalUpdater />
        <Routes>
          {/* <Route path='/request' element={<TestCard />} /> */}
          <Route path="*" element={<App wpData={wpData} />} />
        </Routes>
      </BrowserRouter>

  </React.StrictMode>,
)